function ErrorMessage({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div 
        className="rounded-md border border-gray-300 bg-red-500 py-2 px-3 mb-3"
        {...props}
    />
  )
}

export { ErrorMessage }
